import { forwardRef, type InputHTMLAttributes } from 'react';

/** Edit only the civil date; the owning form keeps the operation's original time. */
export function replaceOperationCivilDate(original: string, civilDate: string): string {
  const timeOffset = original.indexOf('T');
  return civilDate + (timeOffset < 0 ? '' : original.slice(timeOffset));
}

/** Match Android's calendar guards before converting the edited local day to ISO. */
export function parseOperationCivilDate(civilDate: string, original: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/u.exec(civilDate);
  if (!match) throw new Error('Введите дату в формате ГГГГ-ММ-ДД');
  const [year, month, day] = match.slice(1).map(Number);
  const date = new Date(original);
  date.setFullYear(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    throw new Error('Проверьте дату');
  }
  if (date.getTime() > Date.now()) throw new Error('Дата не может быть в будущем');
  return date.toISOString();
}

type OperationDateFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> & {
  value: string;
  onChange: (value: string) => void;
};

export const OperationDateField = forwardRef<HTMLInputElement, OperationDateFieldProps>(function OperationDateField(
  { value, onChange, className = '', ...props }, ref,
) {
  return <input
    {...props}
    ref={ref}
    className={`operation-civil-date ${className}`.trim()}
    type="text"
    aria-label={props['aria-label'] ?? 'Дата операции'}
    value={value.split('T')[0]}
    placeholder="ГГГГ-ММ-ДД"
    maxLength={10}
    onChange={event => onChange(replaceOperationCivilDate(value, event.target.value))}
  />;
});
